import React, { useState } from 'react'
import Joyride from 'react-joyride';
import { useTranslation } from 'react-i18next';
import { redirectTo } from 'src/utils/Http';
import { optionStyles, locale } from '../customize';

export default function NextStep({ setTutorialStep1, setTutorialStep2 }) {
    const [run, setRun] = useState(true)
    const { t } = useTranslation()

    const checkLocationPath = (target) => {
        return window.location.pathname == '/clients' ? target : '.NotFoundClass'
    }
    const step = [
        {
            target: checkLocationPath(".Sidebar__naviItemWrap--2h0Fb:nth-child(1) a[href='/dashboards'] svg"),
            content: t('features.GuideTour.ClientInfoStep.NextStep'),
            placement: 'auto',
            disableBeacon: true,

        },
        {
            target: checkLocationPath(".Sidebar__naviItemWrap--2h0Fb:nth-child(1) a[href='/dashboards'] svg"),
            content: t('features.GuideTour.ClientInfoStep.NextStep'),
            placement: 'auto',
        },
    ];

    const handleCallback = data => {
        const { action, index, lifecycle, type } = data;
        if (action === 'skip') {
            setTutorialStep1(undefined)
        }
        if (type === 'step:after' && index === 0) {
            if (action === 'next') {
                setRun(false)
                setTutorialStep1(undefined)
                setTutorialStep2({ run: true, stepIndex: 0, tourCompleted: false, type: 'create' })
                redirectTo('/dashboards')
            }
        }
    };

    return (
        <Joyride
            steps={step}
            run={run}
            stepIndex={0}
            callback={handleCallback}
            styles={optionStyles}
            locale={locale(t)}
            continuous
            showSkipButton
            scrollToFirstStep
            hideCloseButton
            disableOverlayClose />
    )
}

